import DailyStatsByDayList from './DailyStatsByDayList'

export default { list: DailyStatsByDayList }
